module.exports = __webpack_public_path__ + "img/customize-gb.3c87177b.webp";